import React, { Component } from 'react';

export default class ThanksCard extends Component {

    render(){
        const fillStyle = {fill:this.props.fillColor}
        return (
            <svg width="100%" height="100%" viewBox="0 0 80 80" style={this.props.svgStyle}>
              <g style={fillStyle}>
                <path d="M40,35.129c-5.366,0 -9.712,4.388 -9.712,9.8c0,5.413 4.346,9.8 9.712,9.8c5.366,0 9.712,-4.387 9.712,-9.8c0,-5.412 -4.346,-9.8 -9.712,-9.8Z"/>
                <path d="M74.807,21.211l-9.16,0c-2.043,0 -3.897,-1.211 -4.734,-3.091l-2.742,-6.143c-0.837,-1.877 -2.692,-3.088 -4.736,-3.088l-26.87,0c-2.043,0 -3.899,1.211 -4.739,3.088l-2.739,6.143c-0.837,1.88 -2.69,3.091 -4.734,3.091l-9.16,0c-2.869,0 -5.193,2.346 -5.193,5.237l0,39.426c0,2.891 2.324,5.237 5.193,5.237l69.614,0c2.866,0 5.193,-2.346 5.193,-5.237l0,-39.426c0,-2.891 -2.327,-5.237 -5.193,-5.237Zm-34.807,41.89c-9.951,0 -18.015,-8.135 -18.015,-18.172c0,-10.036 8.064,-18.174 18.015,-18.174c9.951,0 18.015,8.138 18.015,18.174c0,10.037 -8.064,18.172 -18.015,18.172Z"/>
              </g>
            </svg>
        )
    }
}
